import "./CustomerService.css";

function CustomerService(): JSX.Element {
    return (
        <div className="CustomerService">
            Customer Service
        </div>
    );
}

export default CustomerService;
